// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  DATE_LABEL: 'Pickup date',
  DATE_PLACEHOLDER: 'Select desired pickup date',
  TIME_LABEL: 'Pickup time',
  TIME_PLACEHOLDER: 'Select desired pickup time',
  WAITING_TIME_NOTICE: '{minutes} free wait time',
  DRIVER_ARRIVE: 'I want my driver to arrive',
  DRIVER_PICKUP: 'I want to arrive to the airport',
  ARRIVE_TIME_SUFFIX: '{amount} my landing time {exactTime}',
  PICKUP_TIME_SUFFIX: '{amount} flight time {exactTime}',
  EXACT_PICKUP_TIME: '({time})',
  RECOMMENDED_EXACT_PICKUP_TIME: '({time} - Recommended)',
  TIME_BEFORE: '{time} before',
  TIME_AFTER: '{time} after',
  SELECT_TIME_INTERVAL: '(select time adjustment)',
  RIGHT_AFTER_LANDING: 'right after',
  ESTIMATED_ARRIVAL_NOTE:
    'Note: Estimated arrival assumes typical traffic, and may be different depending on traffic conditions',
  FREE_WAITING_MINUTES:
    'The driver will wait {minutes} minutes for free. Extra waiting time will be charged separately.',
  SWITCH_TO_EXACT_TOOLTIP: 'Do you want to set exact pickup time? {link}',
  SWITCH_TO_EXACT_LINK: 'Show exact time selector',
  SWITCH_TO_RELATIVE_TOOLTIP:
    'You can switch back to a relative selector. {link}',
  SWITCH_TO_RELATIVE_LINK: 'Show relative time selector',
  PICKUP_WITH_TRAIN:
    'For Your {isReturnTrip, select, true {Return Train} other {Train}} {isArriving, select, true {Arriving at} other {Departing from}} {placeName}',
  PICKUP_WITH_AIRPORT:
    'For Your {isReturnTrip, select, true {Return Flight} other {Flight}} {isArriving, select, true {Arriving at} other {Departing from}} {placeName}',
  PICKUP_WITH_CRUISE:
    'For Your {isReturnTrip, select, true {Return Cruise} other {Cruise}} {isArriving, select, true {Arriving at} other {Departing from}} {placeName}',
  PICKUP_WITH_POINT: 'For Your Ride From {placeName}',
  PICKUP_CHANGED_NOTICE_TITLE: 'Pickup Time Updated',
  PICKUP_CHANGED_NOTICE_MESSAGE:
    "You requested to be picked up on {originTime}. The provider's closest available pickup time is {newTime}. We've automatically selected it for you.",
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_PICKUP_TIME_FIELD',
  MESSAGES
)
